/** Dev-only mock shops — set REACT_APP_USE_MOCK_SHOPS=true to skip Google Places. */
import mockNearby from './mock-nearby.json';
import mockCollection from './mock-collection.json';

// NODE_ENV first: CRA only emits a DefinePlugin entry for REACT_APP_* vars that exist at
// build time, so in prod (where this one is unset) the REACT_APP_ check stays a runtime
// lookup and keeps both fixtures in the bundle. "production" !== "production" folds to
// false and drops them, without depending on a Netlify setting being remembered.
export const USE_MOCK_SHOPS =
  process.env.NODE_ENV !== 'production' && process.env.REACT_APP_USE_MOCK_SHOPS === 'true';

// Deliberately functions, not consts: a top-level `const x = mockNearby.shops` references
// the JSON unconditionally and pins both fixtures into the production bundle. Behind
// functions they go unreachable once USE_MOCK_SHOPS folds to false, and get shaken out.
export const getMockNearbyShops = () => mockNearby.shops;
export const getMockNearbyCenter = () => mockNearby.center;
export const getMockListsIndex = () => mockCollection.listsIndex;

export const getMockListDetail = (slug) => ({
  ...mockCollection.list,
  slug: slug || mockCollection.list.slug,
  entries: mockCollection.entries,
});
